import Client from '@/services/api/internal/tools/client';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';

function selfAssign(id, body) {
  const url = `${process.env.P2C_BASE_URI}/requests/${id}/dispatch`;
  return Client.post(url, body).catch(errorHandler);
}

function selfUnassign(id, body) {
  const url = `${process.env.P2C_BASE_URI}/requests/${id}/dispatch`;
  return Client.put(url, body).catch(errorHandler);
}

function setDispActive({ requestId, groupId, isPaused, isAssigned }) {
  if (isPaused) {
    return selfUnassign(requestId, {
      group_id: groupId,
      is_dispatched: 'O',
    });
  }
  if (!isAssigned) {
    return selfAssign(requestId, {
      group_id: groupId,
    });
  }
  return Promise.resolve(null);
}

export { selfAssign, selfUnassign, setDispActive };
